import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* getBatchPushTaskStatus() {
  yield takeEvery(actions.GET_BATCH_PUSH_TASK_STATUS, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/pushTaskManage/status/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_BATCH_PUSH_TASK_STATUS_ENDED });
    }
  });
}

function* triggerPushTaskToStop() {
  yield takeEvery(actions.TRIGGER_PUSH_TASK_TO_STOP, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/pushTaskManage/stopTask/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.TRIGGER_PUSH_TASK_TO_STOP_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getBatchPushTaskStatus), fork(triggerPushTaskToStop)]);
}
